module.exports = __webpack_public_path__ + "static/media/Benifits7.a84fd26d.png";